import useSWR from "swr";
import { api } from "@/lib/api";
import { CaretUp, CaretDown } from "@phosphor-icons/react";

export default function MarqueeTape() {
  const { data } = useSWR("watchlist-live-tape", () => api.liveWatchlist(), {
    refreshInterval: 30000,
    revalidateOnFocus: false,
  });

  const items = Array.isArray(data) ? data.filter((i) => i.quote) : [];
  if (items.length === 0) {
    return (
      <div className="border-b border-zinc-800 bg-[#0a0a0a] h-8 flex items-center px-8">
        <span className="overline text-[10px] text-zinc-600">
          loading tape&hellip;
        </span>
      </div>
    );
  }

  // Duplicate for seamless loop
  const doubled = [...items, ...items];

  return (
    <div
      data-testid="marquee-tape"
      className="border-b border-zinc-800 bg-[#0a0a0a] h-8 overflow-hidden relative"
    >
      <div className="marquee-inner flex items-center h-full gap-8 px-4">
        {doubled.map((it, idx) => {
          const up = (it.quote?.change_pct || 0) >= 0;
          return (
            <div
              key={`${it.id}-${idx}`}
              className="flex items-center gap-2 text-xs tabular"
            >
              <span className="text-zinc-400 font-bold">{it.display_symbol}</span>
              <span className="text-white">
                ${Number(it.quote.price).toLocaleString(undefined, { maximumFractionDigits: 4 })}
              </span>
              <span
                className={`flex items-center gap-0.5 ${
                  up ? "text-[#00FF66]" : "text-[#FF3B30]"
                }`}
              >
                {up ? <CaretUp size={10} weight="bold" /> : <CaretDown size={10} weight="bold" />}
                {Math.abs(it.quote.change_pct).toFixed(2)}%
              </span>
              <span className="text-zinc-700">|</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
